<div class="chip staticChips">
  <div class="mediaContainer">
    <i class="pi" [ngClass]="icon"></i>
  </div>
  <div class="content">
    <span class="value">{{ value }}</span>
    <span class="label">{{ label }}</span>
  </div>
</div>
